import { Asterisk } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";

const costs = [
  "Too many ideas",
  "Too many directions",
  "Second-guessing",
  "Starting without finishing",
  "Borrowed dreams",
  "Waiting for someday",
  "Success that doesn’t feel like yours",
];

export const ProblemSection = () => (
  <section data-testid="problem-section" className="bg-paper text-ink">
    <div className="mx-auto max-w-6xl px-5 py-20 sm:py-28">
      <SectionHead eyebrow="THE REAL COST OF AN UNCLAIMED VISION" dark>
        WHEN YOU HAVEN’T DECIDED
        <br />
        WHAT YOU REALLY WANT,
        <br />
        EVERYTHING GETS <span className="font-serif italic font-medium">YOUR ENERGY.</span>
      </SectionHead>

      <div className="grid gap-12 lg:grid-cols-2">
        <Reveal className="space-y-4 text-base text-ink/70 sm:text-lg">
          <p>Every opportunity looks important. Every new idea becomes another direction.</p>
          <p>You start. You stop. You second-guess. You borrow other people’s definitions of success.</p>
          <p>You accomplish things and wonder why they don’t feel as good as you thought they would.</p>
          <p className="font-semibold text-ink">
            Not because you’re incapable. Because you haven’t chosen a vision powerful enough to make the
            unnecessary things become obvious.
          </p>
        </Reveal>

        <ul data-testid="problem-list" className="space-y-1">
          {costs.map((p, i) => (
            <Reveal key={p} delay={i * 0.05}>
              <li className="group flex items-center gap-4 border-b border-ink/10 py-4 text-xl font-extrabold tracking-tight transition-transform duration-300 hover:translate-x-2 sm:text-2xl">
                <Asterisk className="h-5 w-5 shrink-0 text-ink/30 transition-colors group-hover:text-wine" />
                <span className="uppercase transition-colors group-hover:text-ink/70">{p}</span>
              </li>
            </Reveal>
          ))}
        </ul>
      </div>

      <Reveal className="mt-20 text-center sm:mt-28">
        <p className="text-3xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
          WHEN THE VISION IS CHOSEN,
          <br />
          THE UNNECESSARY BECOMES <span className="font-serif italic font-medium">OBVIOUS.</span>
        </p>
      </Reveal>
    </div>
  </section>
);
